import React, { useEffect, useRef, useState } from 'react';
import Select, { StylesConfig } from 'react-select';
import { getMonth, getYear } from 'date-fns';
import { toNumber } from 'lodash';

interface MonthSelectProps {
    date: Date;
    changeMonth: (year: number) => void;
    onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

const MonthStyles: StylesConfig = {
    indicatorSeparator: (base) => {
        return { ...base, display: 'none' };
    },
    dropdownIndicator: (base) => {
        return { ...base, padding: 0, height: 'inherit' };
    },
    menuList: (base) => {
        return { ...base, height: '15rem', overflowY: 'auto', scrollbarWidth: 'thin', width: 'fit-content', scrollBehavior: 'smooth', };
    },
    valueContainer: (base) => {
        return { ...base, width: '5rem', padding: 0, justifyContent: 'center', height: 'inherit' };
    },
    control: (base) => {
        return { ...base, minHeight: '1rem', height: '2rem' };
    },
};

const MonthSelect: React.FC<MonthSelectProps> = ({
    date,
    changeMonth,
    onKeyDown,
}) => {
    const ref = useRef<HTMLSelectElement>(null);
    useEffect(() => {
        if (ref.current) {
            ref.current?.focus(); // Focus MonthSelect when the datepicker opens
        }
      }, []);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const remappedMonths = months.map((month) => ({
        value: month,
        label: month,
    }));

    const onMenuOpen = () => {
        setTimeout(() => {
            const selectedEl = document.getElementsByClassName("month-select__option--is-selected")[0];
            if (selectedEl) {
                selectedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
        }, 15);
    };


    return (
        <Select
            ref={ref as any}
            className={'month-select'}
            styles={MonthStyles}
            options={remappedMonths}
            value={{ label: months[getMonth(date)], value: months[getMonth(date)] }}
            onChange={(newValue: unknown) => {
                if (newValue && typeof newValue === 'object' && 'value' in newValue) {
                    changeMonth(months.indexOf(newValue.value as string));
                }
            }}
            menuPlacement="auto"
            classNamePrefix="month-select"
            defaultValue={{
                label: months[getMonth(date)],
                value: months[getMonth(date)],
            }}
            onKeyDown={onKeyDown}
            onMenuOpen={onMenuOpen}
            isSearchable={false}
        />
    );
};

export default MonthSelect;